// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
import { Circles } from 'react-loader-spinner'
import { renderNoResults } from '../../../components/global/NoDataFound'
import { getPermitRequestList } from '../../../redux/actions/PermitRequestAction'
import { handlingPermitServiceCriteria, isPermissionExist, phoneMasker, sortPortalPermissionByKey, employerDetailsSection } from '../../../utils/helper'
import moment from 'moment'


// import { errorMessages } from '../../../constants/errorMessages'
// import { Link } from 'react-router-dom'

// let moment = require('moment')

function PermitRequest(props) {
    const { dispatch, loader, partnerDetails } = props
    const [permitRequestList, setPermitRequestList] = useState(EMPTY_ARRAY)
    // const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [displayVehicle, setDisplayVehicle] = useState(false)
    const [accessPermissions, setAccessPermissions] = useState('')

    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    useEffect(() => {
        // setTimeout(
        dispatch(getPermitRequestList()).then((res) => {

            if (res?.data && res?.data.length > 0) {
                let permitrecord = res?.data?.filter((v) => v.approved_status != '1')//PIMS-10316 point 13
                // let permitrecord=res?.data//PIMS-10316 point 13

                setPermitRequestList(permitrecord)
            } else {
                setPermitRequestList('')
            }
        }).catch(() => {
            setPermitRequestList('')
        })
        // , 500)

    }, [EMPTY_ARRAY])

    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }


    return (
        loader ? <span className='ms-2 d-flex justify-content-center'><Circles
            height="50"
            width="50"
            color="var(--bs-primary)"
            ariaLabel="circles-loading"
            visible={true}
        /></span> :
            <div>
                <div className="d-flex justify-content-between mb-4">
                    <h4 className="fw-bold">Permit Request </h4>
                </div>
                {permitRequestList?.length > 0 ? <ul className="permitList">
                    {permitRequestList?.map((item, index) => {
                        if (item == null) return null

                        return (
                            <li className={`TicketCardStyle mb-5 ${item?.approved && item?.approved_status == '1' ? 'active border-success ' : item?.is_rejected == '1' ? 'inactive border-danger ' : 'border-warning'}`} key={index}>

                                <div className='d-flex justify-content-sm-between mb-4 gap-2 align-items-sm-end flex-column flex-sm-row'>
                                    <div id='titles' className='d-flex gap-2  '>
                                        <i className={`fa fa-parking fa-2x   ${item?.approved && item?.approved_status == '1' ? ' text-success ' : item?.is_rejected == '1' ? 'text-danger ' : 'text-secondary'}`}></i>
                                        <div  >
                                            <h4 className='mb-0 fw-bold '>{(isPermissionExist(accessPermissions, 'Hide Facility') && !(item?.permitServices?.some(service => service?.display_facility == 1))) ? null : item?.facility?.full_name ? `${item?.facility?.full_name} -` : ''} </h4>
                                            <small>{item?.permit_type_name} {item?.permit_rate?.rate_description?.is_hide_validity == '0' && item?.permit_rate?.rate_description?.description ? `(${item?.permit_rate?.rate_description?.description})` : ''}</small>

                                        </div>


                                        {/* <small className={item?.is_expired == 0 && item?.cancelled_at == null ? 'text-success' : 'text-white'}><i className='fa fa-circle '></i> {item?.is_expired == 0 && item?.cancelled_at == null ? 'Active' : item?.cancelled_at == null ? 'In-active' : 'Canceled'}</small> */}
                                    </div>
                                    <div className=''>
                                        <small className='fw-bold small lh-0 d-block text-muted'>Permit Status  </small>
                                        <p className='small m-0'> {item?.approved && item?.approved_status == '1' ? 'Approved' : item?.is_rejected == null ? 'Pending' : 'Rejected'}</p>
                                    </div>


                                    <div id='actionButtons' className='text-end' >
                                        <b className='text-muted small lh-0'>Refrence ID: </b>
                                        <h5 className='text-black m-0 fw-bold lh-0 '>{item?.tracking_code}</h5>
                                    </div>

                                </div>
                                <div className='border border-dashed my-4 d-block w-100'></div>

                                {/* <div className={item?.approved  && item?.approved_status == '1' ? 'card-header border-0 bg-success bg-opacity-10' : item?.is_rejected == null ?  'card-header border-0 bg-info bg-opacity-10' : 'card-header border-0 bg-danger bg-opacity-10'} >
                                    <div className='d-flex justify-content-end'>
                                        <small className={item?.approved  && item?.approved_status == '1' ? 'text-success' :  item?.is_rejected == null ? 'text-info' : 'text-white' }><i className='fa fa-circle '></i> {item?.approved  && item?.approved_status == '1' ? 'Approved' : item?.is_rejected == null ? 'Pending' : 'Rejected'}</small>
                                    </div>
                                </div> */}

                                <div className='row g-2'>

                                    <div className='col-md-4 '>
                                        <p><b className='text-muted small'>Name: </b><span className='text-black small'>{item?.name}</span></p>
                                    </div>
                                    <div className='col-sm col-smmd-4 '>
                                        <p><b className='text-muted small'>Email: </b><span className='text-black small'>{item?.email}</span></p>
                                    </div>
                                    <div className='col-md-4 '>
                                        <p><b className='text-muted small'>Phone: </b><span className='text-black small'>{phoneMasker(item?.phone)}</span></p>
                                    </div>
                                    {(item?.reserved_space_number && item?.reserved_space_number != '') ? <div className='col-md-4 '>
                                        <p><b className='text-muted small'>Preferred Reserved Space Number: </b><span className='text-black small'>{item?.reserved_space_number}</span></p>
                                    </div> : null}

                                    {item?.hid_card_number && <div className='col-sm-4 col-12 mb-sm-0 mb-3'>
                                        <p><b className='text-muted small'>Prox Card Id: </b><span className='text-black small'>{item?.hid_card_number}</span></p>
                                    </div>}
                                    {item?.employer_name && <div className='col-sm-4 col-12 mb-sm-0 mb-3'>
                                        <p><b className='text-muted small'>Employer Name: </b><span className='text-black small'>{item?.employer_name ? item?.employer_name :'-'}</span></p>
                                    </div>}
                                    {item?.user_type_id && <div className='col-sm-4 col-12 mb-sm-0 mb-3'>
                                        <p><b className='text-muted small'>Student/Staff/Faculty ID: </b><span className='text-black small'>{item?.user_type_id}</span></p>
                                    </div>}

                                    {item?.license_number && <div className='col-md-4  d-none'>
                                        <span><h5 className='mb-0 fw-bold text-muted small'>Driver License No.:</h5>
                                            <p><b className='text-black small'>{item?.license_number}</b></p></span>

                                        {/* <p className='text-muted mb-0  '>{item?.user?.license_number}<br/>  <b>Driving License No.</b></p> */}
                                    </div>}

                                </div>


                                {employerDetailsSection(item?.employer_details, true)}

                                {item?.is_rejected == '1' && <div className='bg-light horizontal-gradient my-3 p-3 rounded-4'>
                                    <div className="flex gap-4 items-center">

                                        <div>
                                            <span className="text-sm text-muted font-semibold block"> <h5 className='fw-bold m-0 ' >Rejected Reason </h5></span>{item?.reject_reason ? item?.reject_reason : 'N/A'}</div>
                                    </div>
                                </div>}

                                {/* uploaded documents */}
                                {item?.permit_doc && item?.permit_doc?.length > 0 ?
                                    <div className='bg-light  horizontal-gradient my-3 p-3 rounded-4'>
                                        <div className='d-flex align-items-sm-center gap-sm-5 gap-2 flex-column  flex-sm-row'>
                                            <h5 className='fw-bold m-0 ' > <i className='fa fa-file me-2'></i>  Uploaded Document - </h5>

                                            {item?.permit_doc?.length > 0 ?
                                                item?.permit_doc?.map((item, index) => {
                                                    return (

                                                        <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0 '> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>

                                                    )
                                                })
                                                : <div className='col'>
                                                    <span className='fontsize85'>
                                                        N/A
                                                    </span>
                                                </div>}
                                        </div>
                                    </div> : null}

                                {/* <div className='bg-light horizontal-gradient my-3 p-3 rounded-4'>
                                    <div className='d-flex align-items-sm-center gap-sm-5 gap-2 flex-column  flex-sm-row'>
                                        <h5 className='fw-bold m-0 ' > <i className='fa fa-file me-2'></i>  Uploaded Document - </h5>

                                        {item?.permit_doc?.length > 0 ?
                                            item?.permit_doc?.map((item, index) => {
                                                return (

                                                    <a key={index} href={`${item[item?.document_key]}`} target='_blank' rel="noreferrer" className='text-primary text-start btn p-0 '> <span className="text-dark">{item?.doc_name}</span> <i className='fa fa-eye'></i></a>

                                                )
                                            })
                                            : <div className='col'>
                                                <span className='fontsize85'>
                                                    N/A
                                                </span>
                                            </div>}
                                    </div>
                                </div> */}




                                {item?.permitServices?.length > 0 ? <div className='py-2 border-top'>
                                    <b>Permit Services(s)</b>

                                    {item?.permitServices?.map((v, i) => {
                                        if (v?.permit_service_name != 'Select All Access') {
                                            return (

                                                <div key={i} className='d-flex  px-0   w-full align-items-center justify-content-between'>
                                                    <div className=' text-muted text-capitalize' >
                                                        {v?.permit_service_name} {(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}


                                                    </div>
                                                    {/* <div className='fw-semibold '>
                                                                ${v?.permit_service_rate}
                                                            </div> */}
                                                </div>
                                            )
                                        }

                                    })}
                                </div> : ''}

                                {item?.permit_vehicle && item?.permit_vehicle?.length > 0 && <div className='my-3'>
                                    <div className="border border-dashed my-4 d-block w-100"></div>
                                    <div className="d-flex align-items-center mb-2 w-full justify-content-between">
                                        <b>Vehicle(s)</b>{item?.permit_vehicle?.length > 1 ? <button className='btn btn-outline-dark btn-sm btn-sm' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</button> : null}
                                    </div>
                                    <div className='table-responsive'>
                                        <table style={{ minWidth: '400px' }} className='table table-sm table-borderless' >
                                            <thead scope="row" >
                                                <th scope='col' className='small text-muted fw-normal '>License Plate</th>
                                                <th scope='col' className='small text-muted fw-normal '>Make</th>
                                                {allHaveMst_model ? <th scope='col' className='small text-muted fw-normal ' >Model</th> : null}
                                                {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <th scope='col' className='small text-muted fw-normal'>Vehicle Type</th> : null}
                                                <th scope='col' className='small text-muted fw-normal ' >Color</th>
                                                {isPermissionExist(accessPermissions, 'Get Vehicle Style') && <th scope='col' className='small text-muted fw-normal '>Style</th>}

                                                {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && <th scope='col' className='small text-muted fw-normal '>Country</th>}

                                                <th scope='col' className='small text-muted fw-normal '>State</th>

                                                {(isPermissionExist(accessPermissions, 'Vin Number')) && <th scope='col' className='small text-muted fw-normal' >VIN</th>}


                                                {/* {item?.permit_vehicle[0]?.vehicle?.license_plate_number && <th scope='col' className='small text-muted fw-normal '>License Plate</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.color && <th scope='col' className='small text-muted fw-normal ' >Color</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.make && <th scope='col' className='small text-muted fw-normal '>Make</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.model && <th scope='col' className='small text-muted fw-normal ' >Model</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.country && isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && <th scope='col' className='small text-muted fw-normal '>Country</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.state_code && <th scope='col' className='small text-muted fw-normal '>State</th>
                                            }
                                            {item?.permit_vehicle[0]?.vehicle?.vehicle_number && (isPermissionExist(accessPermissions, 'Vin Number')) && <th scope='col' className='small text-muted fw-normal ' >VIN</th>
                                            } */}
                                            </thead>
                                            <tbody>
                                                {!displayVehicle && <tr>
                                                    {item?.permit_vehicle[0]?.vehicle?.license_plate_number ? <td className='p-0 lh-4'  ><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png" />  {item?.permit_vehicle[0]?.vehicle?.license_plate_number}</td> : <td>-</td>
                                                    }

                                                    {item?.permit_vehicle[0]?.vehicle?.make ? <td className='p-0 lh-4'   > <i className='fa small opacity-25 fa-car'></i> {item?.permit_vehicle[0]?.vehicle?.make}</td>
                                                        : <td>-</td>}
                                                    {item?.permit_vehicle[0]?.vehicle?.model && allHaveMst_model ? <td className='p-0 lh-4'  > <i className='fa small opacity-25 fa-car-side'></i>  {item?.permit_vehicle[0]?.vehicle?.model}</td>
                                                        : null}
                                                    {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td className='p-0 lh-4'>{item?.permit_vehicle[0]?.vehicle?.vehicle_type ? item?.permit_vehicle[0]?.vehicle?.vehicle_type : '-'}</td> : null}
                                                    {item?.permit_vehicle[0]?.vehicle?.color ? <td className='p-0 lh-4'  > <i className='fa small opacity-25 fa-palette'></i> {item?.permit_vehicle[0]?.vehicle?.color}</td>
                                                        : <td>-</td>}
                                                    {(item?.permit_vehicle[0]?.vehicle?.style && isPermissionExist(accessPermissions, 'Get Vehicle Style')) ? <td className='p-0 lh-4'   >  {item?.permit_vehicle[0]?.vehicle?.style}</td>
                                                        : <td>-</td>}
                                                    {(item?.permit_vehicle[0]?.vehicle?.country && isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode')) ? <td className='p-0 lh-4'   >  {item?.permit_vehicle[0]?.vehicle?.country}</td>
                                                        : <td>-</td>}
                                                    {item?.permit_vehicle[0]?.vehicle?.state_code ? <td className='p-0 lh-4'   >  {item?.permit_vehicle[0]?.vehicle?.state_code}</td>
                                                        : <td>-</td>}
                                                    {(item?.permit_vehicle[0]?.vehicle?.vehicle_number && (isPermissionExist(accessPermissions, 'Vin Number'))) ? <td className='p-0 lh-4'>  {item?.permit_vehicle[0]?.vehicle?.vehicle_number}</td>
                                                        : <td></td>}
                                                </tr>}


                                                {displayVehicle && item?.permit_vehicle && <>
                                                    {item?.permit_vehicle?.length > 0 && item?.permit_vehicle?.map((item, index) => {
                                                        return <tr key={index}>
                                                            <td className='p-0 lh-4' ><img height="18px" className='opacity-25' src="https://cdn-icons-png.flaticon.com/512/2260/2260153.png" /> {item?.vehicle?.license_plate_number ? item?.vehicle?.license_plate_number : '-'}</td>

                                                            <td className='p-0 lh-4' >{item?.vehicle?.make && <i className='fa small fa-car opacity-25'></i>} {item?.vehicle?.make ? item?.vehicle?.make : '-'}</td>
                                                            {allHaveMst_model && <td className='p-0 lh-4' >{item?.vehicle?.model && <i className='fa small fa-car-side opacity-25'></i>} {item?.vehicle?.model ? item?.vehicle?.model : '-'}</td>}
                                                            {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td className='p-0 lh-4' >{item?.vehicle?.vehicle_type ? item?.vehicle?.vehicle_type : '-'}</td> : ''}
                                                            <td className='p-0 lh-4' >{item?.vehicle?.color && <i className='fa small fa-palette opacity-25'></i>} {item?.vehicle?.color ? item?.vehicle?.color : '-'}</td>
                                                            {isPermissionExist(accessPermissions, 'Get Vehicle Style') && item?.vehicle?.style ? <td className='p-0 lh-4' >{item?.vehicle?.style ? item?.vehicle?.style : '-'}</td> : ''}

                                                            {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && item?.vehicle?.country ? <td className='p-0 lh-4' >{item?.vehicle?.country ? item?.vehicle?.country : '-'}</td> : ''}
                                                            <td className='p-0 lh-4' >{item?.vehicle?.state_code ? item?.vehicle?.state_code : '-'}</td>

                                                            {(isPermissionExist(accessPermissions, 'Vin Number')) && item?.vehicle?.vehicle_number ? <td className='p-0 lh-4' >{item?.vehicle?.vehicle_number ? item?.vehicle?.vehicle_number : '-'}</td> : ''}
                                                        </tr>
                                                    })}



                                                </>}

                                            </tbody>
                                        </table></div>

                                </div>
                                }





                                {/* driver */}
                                {item?.authorized_driver && item?.authorized_driver.length > 0 && <div className='col-12 col-sm-12 order-sm-1 order-4 mt-sm-0'>
                                    <table className='table mt-3' cellSpacing="0px" cellPadding="0">
                                        <tr>
                                            <th className='text-muted border ps-2'>Driver Name:</th>
                                            <th className='text-muted border ps-2'>Document:</th>

                                        </tr>
                                        {item?.authorized_driver?.map((v, i) => {
                                            return (<>
                                                <tr key={i}>
                                                    <td className='small border ps-2'>{v?.driver_name}</td>

                                                    <td className='small border ps-2'>{v?.url ? <a href={v?.url} target='_blank' rel="noreferrer">View </a> : '-'}</td>


                                                </tr></>)
                                        })}

                                    </table>
                                    {/* {item?.permit_vehicle?.length > 1 ? <span className=' fw-bold text-primary text-decoration-underline' onClick={() => handleshowVehicle()}>{displayVehicle ? 'Hide All' : 'View All'}</span> : null} */}

                                </div>
                                }
                                <div className='border border-dashed my-4 d-block w-100'></div>

                                {(item?.keycard && (Object.keys(item?.keycard || {})?.length > 0)) ? <>
                                    <b className='mainText'> Key Card Details</b>
                                    <div className='row g-1 row-cols-1 row-cols-sm-3' >
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Key Card Enabled  </small>
                                            <p className='m-0'> Yes</p>
                                        </div>
                                        {/* <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Key Card Name  </small>
                                            <p className='m-0'> {item?.keycard?.name || '-'}</p>
                                        </div> */}
                                        <div className='col'>
                                            <small className='fw-bold text-muted d-block'> Key Card Amount  </small>
                                            <p className='m-0'>{(item?.keycard && item?.keycard?.price) ? `$${Number(item?.keycard?.price?.replace(',', ''))?.toFixed(2)}` : '-'}</p>
                                        </div>
                                    </div>
                                </> : null}



                                {/*  transtion card detils */}
                                <div className='border border-dashed my-4 d-block w-100'></div>

                                {item?.business_id && item?.business_id != '' ? null : <div className='row g-1 row-cols-1 row-cols-sm-4' >
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Amount paid  </small>
                                        <p className='m-0'> ${item?.permit_final_amount}</p>
                                    </div>
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Transaction Number  </small>
                                        <p className='m-0'>{item?.transaction?.anet_trans_id ? item?.transaction?.anet_trans_id : '-'}</p>
                                    </div>
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Card details </small>
                                        {Number(item?.permit_final_amount) > 0 ? <><p className='m-0'>Ending With - {item?.paymentDetails?.card_last_four} </p>
                                            <p> Exp - {item?.paymentDetails?.expiry ? item?.paymentDetails?.expiry?.slice(0, 2) + '/' + item?.paymentDetails?.expiry?.slice(2, 4) : ''}</p>
                                        </> : '-'} </div>
                                    <div className='col'>
                                        <small className='fw-bold text-muted d-block'> Payment Date  </small>
                                        {item?.transaction?.created_at ? <p className='m-0'><i className='fa fa-clock'></i> {moment(item?.transaction?.created_at).format('MM/DD/YYYY hh:mm a')}</p> : '-'}
                                    </div>

                                </div>}
                                <div className='row g-2 d-none' >

                                    <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'> Permit Rate  </small>
                                        <p className='m-0'>{item?.permit_rate?.rate}</p>
                                    </div>
                                    <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'> Amount  </small>
                                        <p className='m-0'>{item?.permit_final_amount}</p>
                                    </div>
                                    {item?.paymentDetails?.card_last_four ? <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'>Card details </small>
                                        <p className='m-0'>Ending With -
                                            {/* <i className="fa-brands fa-cc-visa"></i> */}
                                            {item?.paymentDetails?.card_last_four} </p>

                                        <p> Exp - {item?.paymentDetails?.expiry ? item?.paymentDetails?.expiry?.slice(0, 2) + '/' + item?.paymentDetails?.expiry?.slice(2, 4) : ''}</p>
                                    </div> : ''}
                                    <div className='col-md-4'>
                                        <small className='fw-bold text-muted d-block'> Payment Date  </small>
                                        {Number(item?.permit_final_amount) > 0 ? <p className='m-0'><i className='fa fa-clock'></i> {moment(item?.paymentDetails?.created_at).format('MM/DD/YYYY hh:mm a')}</p> : '-'}

                                        {/* <p className='m-0'><i className='fa fa-clock'></i>  12th Aug, 2024 12:20 PM </p> */}
                                    </div>
                                </div>




                            </li>
                        )
                    })}
                </ul> : renderNoResults()}
            </div>
    )
}

PermitRequest.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    partnerDetails: PropTypes.object,
}

PermitRequest.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ permitRequestReducer, PartnerReducer }) {
    return {
        loader: permitRequestReducer?.loader,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(PermitRequest)